import { DashBoardDonutCard } from '../../../../../components/UI-Elements/DashBoardDonutCard';
import { FormatToShortPriceTemplate } from '../../../../../utils/FormatValue';
import { mockOpportunityRouteData } from '@pages/Opportunity-dashboard/opportunityTransactionsMock';
import { ITransactionOpportunity, IOpportunityRouteData } from '@sp-types/transactionOpportunityType';
import React from 'react';

interface Props {
  data: ITransactionOpportunity[];
}

export const OpportunityDoughChart: React.FC<Props> = ({ data }) => {
  return (
    <div className="flex flex-col flex-1 gap-3">
      <p className="text-lg font-medium">Routes distribution</p>
      <div className="flex flex-1 flex-row gap-4">
        <div className="w-[10rem] ">
          <DashBoardDonutCard secondaryTitle="Total Value" dataSet={getDouChartData(data, mockOpportunityRouteData)} />
        </div>
        <OpLegendSection data={getDouChartData(data, mockOpportunityRouteData)} addPrecText={true} />
      </div>
    </div>
  );
};

interface ISingleLegendLineProps {
  data: { color: string; fieldName: string; value: number; suffix?: string }[];
  addPrecText?: boolean;
}

export const OpLegendSection: React.FC<ISingleLegendLineProps> = ({ data, addPrecText }) => {
  const totalAmount = data.reduce((acc, item) => (acc += item.value), 0);

  return (
    <div className="flex flex-col justify-between flex-1 overflow-auto">
      {data.map((item, index) => (
        <div className="flex flex-row gap-2" key={index}>
          <div
            className=" rounded-sm mt-1"
            style={{
              width: '10px',
              height: '10px',
              backgroundColor: item.color,
            }}
          ></div>
          <div className="flex flex-col flex-1">
            <p className="text-sm text-gray-450">{item.fieldName}</p>
            <p className="text-md">
              {`${FormatToShortPriceTemplate(item.value)}${
                addPrecText ? ` (${((item.value / totalAmount) * 100).toFixed(0)}%)` : ''
              }`}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

const getDouChartData = (
  data: ITransactionOpportunity[],
  opportunityRouteDataDict: Record<string, IOpportunityRouteData>,
): { color: string; fieldName: string; value: number; ratio: number }[] => {
  const reducedDataByRoute = data.reduce((acc, item) => {
    const firstRoute = item.routesOptionData[0];
    if (firstRoute) {
      const { routeId } = firstRoute;
      if (!acc[routeId]) {
        acc[routeId] = {
          routeId,
          totalQuantity: 0,
          totalValue: 0,
        };
      }
      acc[routeId].totalQuantity += item.quantity;
      acc[routeId].totalValue += item.quantity * firstRoute.buyingPrice;
    }
    return acc;
  }, {} as Record<string, { routeId: string; totalQuantity: number; totalValue: number }>);

  return Object.values(reducedDataByRoute).map(({ routeId, totalValue }) => ({
    color: opportunityRouteDataDict[routeId].color,
    fieldName: opportunityRouteDataDict[routeId].name,
    value: totalValue,
    ratio: 0,
  }));
};
